import '../App.css';
import Login from "../Pages/Login/Login";
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Productinfo from "../../src/Pages/ProductInfo/index";
import CategortProductListing from "../../src/Pages/CategoryProductListing/index";
import CategoryPage from "../../src/Pages/CategoryPage/index";
import ForgotPassword from "../../src/Pages/ForgotPassword/index";
import ChangePassword from "../../src/Pages/ChangePassword/ChangePassword";
import Filter from "../Pages/TestPage";
import React from "react";
import LikedProducts from "../Pages/LikedProducts/LikedProducts";
import VisitHistory from "../Pages/VisitHistory/VisitHistory";
import WishlistSharedHistory from "../Pages/WishlistSharedHistory";
import UserMaster from '../Pages/UserMaster';

function AppRouter() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/forgetpassword" element={<ForgotPassword />} />
                <Route path="/changepassword" element={<ChangePassword />} />
                <Route path="/categorylisting" element={<CategoryPage />} />
                <Route path="/recentvisit" element={<VisitHistory />} />
                <Route path="/wishlistsharedhistory" element={<WishlistSharedHistory />} />
                <Route path="/wishlistproducthistory" element={<LikedProducts />} />
                <Route path="/usermaster" element={<UserMaster />} />
                <Route path="/productinfo" element={<Productinfo />} />
                <Route path="/categoryproductlisting" element={<CategortProductListing />} />
            </Routes>
        </Router>
    );
}

export default AppRouter;
